<template>
  <memlist-card>

    <m-row>
      <m-col cols="6" >
        <memlist-text-input
          v-model="filter"
          :title="$t('USER.SEARCH_COMPANY')"
          layout="vertical"
          type="text"
          size="sm"
        />

      </m-col>
      <m-col cols="6">
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="companies.length" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
            aria-controls="search-result-table"
          />

        </div>
      </m-col>
    </m-row>

    <memlist-static-table
      id="search-result-table"
      :filter="filter"
      :items="companies"
      :fields="showFields"
      :per_page="per_page"
      :current_page="current_page"
    >
      <template #cell(actions) ="data">
        <div class='d-flex justify-content-end'>
          <a
            href="#"
            class="btn btn-icon btn-light btn-sm mx-3"
            @click="selectCompanyClicked(data.item.id)"
          >
            <span class="svg-icon svg-icon-md svg-icon-primary">
              <!--begin::Svg Icon-->
              <inline-svg src="/assets/svg/pencil-square.svg"></inline-svg>
              <!--end::Svg Icon-->
            </span>
          </a>
          <a href="#" class="btn btn-icon btn-light btn-sm" @click="deleteCompanyClicked(data.item.id)">
            <span class="svg-icon svg-icon-md svg-icon-primary">
              <!--begin::Svg Icon-->
              <inline-svg src="/assets/svg/trash2.svg"></inline-svg>
              <!--end::Svg Icon-->
            </span>
          </a>
        </div>
      </template>
    </memlist-static-table>
      
  </memlist-card>
</template>

<style lang="scss" scoped>

</style>


<script>
import axios from 'axios';
import CompaniesTableRow from '@/view/pages/ml/companies/CompaniesTableRow.vue';

import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'companies-table',
  components: {
    CompaniesTableRow
  },
  emits: ['selectCompanyClicked', 'deleteCompanyClicked'],
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies'])
  },
  watch: {
    companies(newValue, oldvalue) {

    }
  },
  mounted() {

  },
  methods: {
    createCompanyClicked() {},
    selectCompanyClicked(company_id) {
      this.$emit('selectCompanyClicked', company_id);
    },
    deleteCompanyClicked(company_id) {
      this.$emit('deleteCompanyClicked', company_id);
    },

  },
  data() {
    return {
      list: [],
      per_page: 100,
      current_page: 1,
      options: [100, 150, 200],
      showFields: [
        { key: 'name', label: 'Förening', show: true, sortable: true, thClass: 'w-100' },
        { key: 'actions', label: this.$t('COMMON.ACTIONS'), show: true, sortable: false, thClass:'w-100'}
      ],
      filter: ''
    };
  }
};
</script>
